export default __webpack_public_path__ + "static/media/ueber-ssv-kroschke.4dbf3e1c.webp";